const actions = {
  SET_STATE: "credential/SET_STATE",
  CREATE: "credential/CREATE",
  DELETE: "credential/DELETE",
  CLEAR: "credential/CLEAR",
};

export default actions;
